import { Timestamp } from 'firebase/firestore';
import _ from 'lodash';
import { QuestionConfig, QuestionSet, QuestionSetId } from '../types/GameplayTypes';

export abstract class QuestionProvider {
	/** Implement to provide Question Set. Does not need to be normalized. */
	protected abstract questionData(questionSetId?: QuestionSetId): Promise<QuestionSet>;

	/** Returns the normalized Question Set */
	public async questions(questionSetId?: QuestionSetId): Promise<QuestionSet> {
		const questionSet = await this.questionData(questionSetId);
		questionSet.questions = this.normalizeQuestions(questionSet.questions);
		return questionSet;
	}

	// TODO: Should we also enforce answers add up to 100 here? Report error?
	private normalizeQuestions(rawQuestions: QuestionConfig[]): QuestionConfig[] {
		const normalized = _.cloneDeep(rawQuestions);
		for (const question of normalized) {
			question.answers = question.answers.sort((a, b) => (b.points - a.points));
		}
		return normalized;
	}
};

/** Hardcoded questions for initial development & testing */
export class HardcodedQuestionProvider extends QuestionProvider {
	private readonly metadata = {
		tags: ['mental-health'],
		isActive: true,
		createdAt: Timestamp.now().toMillis(),
		updatedAt: Timestamp.now().toMillis(),
		authorName: 'Hardcoded',
	};

	protected async questionData(): Promise<QuestionSet> {
		return {
			id: 'qset1',
			name: 'Question Set 1',
			description: 'A hardcoded Question Set',
			...this.metadata,

			questions: [{
				id: 'q1',
				text: 'Name something you might find in a therapist\'s office',
				answers: [
					{ text: 'Diplomas/Certificates', points: 15 },
					{ text: 'Tissues', points: 25 },
					{ text: 'Chair', points: 10 },
					{ text: 'Couch', points: 38 },
					{ text: 'Books', points: 7 },
					{ text: 'Plants', points: 5 },
				],
				...this.metadata,
			}, {
				id: 'q2',
				text: 'Name a coping skill people use to manage stress',
				answers: [
					{ text: 'Meditation', points: 12 },
					{ text: 'Exercise', points: 25 },
					{ text: 'Deep breathing', points: 30 },
					{ text: 'Talking to someone', points: 20 },
					{ text: 'Journaling', points: 5 },
					{ text: 'Music', points: 8 },
				],
				...this.metadata,
			}, {
				id: 'q3',
				text: 'Name something people do to practice self-care',
				answers: [
					{ text: 'Get enough sleep', points: 22 },
					{ text: 'Take a bath/shower', points: 28 },
					{ text: 'Eat healthy', points: 14 },
					{ text: 'Exercise', points: 18 },
					{ text: 'Spend time with friends', points: 10 },
					{ text: 'Read a book', points: 8 },
				],
				...this.metadata,
			}],
		};
	}
}
